import { transitionZoomLevel } from './apple-maps';
import { convertFilterAndPositionToUrlParams } from './listing-query-helper';

import type { ListingParams } from 'contexts/preferences/listing-params/types';

export default function getSearchPageParameters(listingParams: ListingParams) {
  const urlParams = convertFilterAndPositionToUrlParams(listingParams, listingParams.filter.latitude, listingParams.filter.longitude, transitionZoomLevel);
  return `/search?${urlParams.toString()}`;
}
